import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getTestCaseData } from '../../modules/config';
import { getAssociatedUsers, getCurrentProject } from '../../modules/project';
import AddTestCaseModal from '../../components/project-dashboard/test-cases/AddTestCaseModal';

const GenerateTestCasesAgent = ({ open, onClose, projectId }) => {
  const navigate = useNavigate();

  const [statuses,        setStatuses]        = useState([]);
  const [priorities,      setPriorities]      = useState([]);
  const [labels,          setLabels]          = useState([]);
  const [modules,         setModules]         = useState([]);
  const [testSuites,      setTestSuites]      = useState([]);
  const [technologyLayers,setTechnologyLayers]= useState([]);
  const [projectUsers,    setProjectUsers]    = useState([]);
  const [isReviewWorkflow,setIsReviewWorkflow]= useState(false);
  const [loading,         setLoading]         = useState(false);

  useEffect(() => {
    if (!open || !projectId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const [usersResponse, tcData, projectData] = await Promise.all([
          getAssociatedUsers(projectId),
          getTestCaseData(projectId),
          getCurrentProject(projectId),
        ]);

        if (tcData) {
          setStatuses(tcData.result.filter((i) => i.group === 'TEST_CASE_STATUS'));
          setPriorities(tcData.result.filter((i) => i.group === 'TEST_CASE_PRIORITY'));
          setLabels(tcData.result.filter((i) => i.group === 'LABEL'));
          setModules(tcData.result.filter((i) => i.group === 'FUNCTIONAL_MODULE_FIELD'));
          setTechnologyLayers(tcData.result.filter((i) => i.group === 'TECHNOLOGY_LAYER'));
          setTestSuites(tcData.test_suites);
        }
        if (usersResponse) {
          setProjectUsers(usersResponse.map((u) => ({ ...u.user, role: u.role })));
        }
        if (projectData) {
          setIsReviewWorkflow(projectData.review_workflow);
        }
      } catch (error) {
        console.error('GenerateTestCasesAgent: failed to fetch data', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [open, projectId]);

  const handleSuccess = (aiGeneratedKeys) => {
    navigate(`/project/${projectId}/testcases`, {
      state: aiGeneratedKeys?.length > 0 ? { aiGeneratedKeys } : undefined,
    });
  };

  return (
    <AddTestCaseModal
      showModal={open}
      handleClose={onClose}
      projectId={projectId}
      statuses={statuses}
      priorities={priorities}
      labels={labels}
      modules={modules}
      testSuites={testSuites}
      technologyLayers={technologyLayers}
      projectUsers={projectUsers}
      isReviewWorkflow={isReviewWorkflow}
      loading={loading}
      refetchData={handleSuccess}
      initialMode="ai"
    />
  );
};

export default GenerateTestCasesAgent;